import { select, takeLatest, call, put } from 'redux-saga/effects';
// import { push } from 'react-router-redux';

import {
  _getPinForAuthorize,
  _getPinForAuthorizeLoaded,
  _getPinForAuthorizeError,
  _getCodeOfAuthorizeLoaded,
  _getCodeOfAuthorizeError,
  setPropsFormPinRequest,
  setPropsFormPhoneNumerRequest,
  setUrlFormToSubscription
  // _showMessageWithoutSubscription
} from './actions';

import {
  GET_PIN_FOR_AUTHORIZE,
  GET_CODE_OF_AUTHORIZE,
  EDIT_PHONE_NUMBER,
  MSG_PHONE_NUMBER_EMPTY,
  MSG_PHONE_NUMBER_INCONPLETE,
  MSG_PHONE_NUMBER_INVALID_TO_SEND_PIN,
  MSG_PIN_NUMBER_EMPTY,
  MSG_PIN_INVALID,
  MSG_PIN_INCOMPLETE,
  MSG_PIN_LIMIT_REACHED,
  MSG_NUMBER_WIHTOUT_SUBSCRIPTION,
  COUNTRY_CODE,
  MSG_RECAPTCHA_DATA_EMPTY
} from './constants';

import {
  selectPhoneNumber,
  selectPinNumber,
  selectInitialDataConfig
} from './selectors';

import Oauth2Service from '../../services/Oauth2Service';


function* getPinForAuthorize(action) {
  try {
    const state = yield select();
    // eslint-disable-next-line
    const phoneNumber = selectPhoneNumber(state) ? COUNTRY_CODE + selectPhoneNumber(state).toString().match(/\d+/g).toString().replace(',', '') : '';
    const config = selectInitialDataConfig(state);

    if (!phoneNumber) {
      return yield put(_getPinForAuthorizeError({
        message: MSG_PHONE_NUMBER_EMPTY,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    if (phoneNumber.length !== 13) {
      return yield put(_getPinForAuthorizeError({
        message: MSG_PHONE_NUMBER_INCONPLETE,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    if (action.data === 'renew') {
      /*
        TODO:
        - poner en ves de 1 una variable para indentificar que se debe activar el loading
       */
      return yield put(setPropsFormPhoneNumerRequest(1));
    }

    const oAuth2data = yield call(Oauth2Service.sendPin, config, phoneNumber);

    if (oAuth2data.code && oAuth2data.code === 'CPT-001') {
      return yield put(_getPinForAuthorizeError({
        message: MSG_RECAPTCHA_DATA_EMPTY,
        step: GET_PIN_FOR_AUTHORIZE,
        color: 'warning'
      }));
    }

    // Modificar la validacion de result o error para los valores correctos
    // que vienen de respuesta del cliente
    if (!oAuth2data.ok) {
      return yield put(_getPinForAuthorizeError({
        message: MSG_PHONE_NUMBER_INVALID_TO_SEND_PIN,
        color: 'danger'
      }));
    }

    yield put(setPropsFormPinRequest());
    return yield put(_getPinForAuthorizeLoaded({ok: true}));

  } catch (error) {

    return yield put(_getPinForAuthorizeError({
      message: 'Error encontrado',
      color: 'danger'}));

  }
}

/* ========================================================================
=            Function for consulting code to Oauth2/Authorize            =
========================================================================*/

function* getCodeOfAuthorize() {

  try {
    const state = yield select();
    const phoneNumber = COUNTRY_CODE + selectPhoneNumber(state)
    .toString().match(/\d+/g).toString()
    .replace(',', '');
    const pinNumber = selectPinNumber(state) ? selectPinNumber(state).toString() : null;
    const config = selectInitialDataConfig(state);

    if (!pinNumber) {
      return yield put(_getCodeOfAuthorizeError({
        message: MSG_PIN_NUMBER_EMPTY,
        color: 'warning'
      }));
    }

    if (pinNumber.length !== 4) {
      return yield put(_getCodeOfAuthorizeError({
        message: MSG_PIN_INCOMPLETE,
        color: 'warning'
      }));
    }

    const data = {
      msisdn: phoneNumber,
      pin: pinNumber
    };

    const oAuth2data = yield call(Oauth2Service.authorize, config, data, false);

    if (oAuth2data.error_description === 'ACCESS_DENIED') {
      yield put(_getPinForAuthorize('renew'));
      yield put(setPropsFormPhoneNumerRequest(1));
      yield put(setUrlFormToSubscription(config.failureRedirect));
      return yield put(_getPinForAuthorizeError({
        message: MSG_NUMBER_WIHTOUT_SUBSCRIPTION,
        color: 'danger'
      }));

      /*
        yield put(_showMessageWithoutSubscription({
          subscriptionUri: oAuth2data.subscription_uri
        }));
        return yield put(push('/login/without_subscription'));
      */
    }

    if (oAuth2data.error_description === 'PIN_LIMIT_REACHED') {
      return yield put(_getCodeOfAuthorizeError({
        message: MSG_PIN_LIMIT_REACHED,
        color: 'danger',
        ok: false
      }));
    }

    if (!oAuth2data.code) {
      return yield put(_getCodeOfAuthorizeError({
        message: MSG_PIN_INVALID,
        color: 'danger',
        ok: false
      }));
    }

    const hasState = config.state ? `&state=${config.state}` : '';
    window.location.assign(`${config.redirect_uri}?code=${oAuth2data.code}${hasState}`);

    return yield put(_getCodeOfAuthorizeLoaded({ok: true}));

  } catch (e) {

    return yield put(_getCodeOfAuthorizeError({
      ok: false,
      message: 'Internal error',
      color: 'danger'
    }));
  }
}

function* _setPropsFormPhoneNumerRequest() {
  yield put(setPropsFormPhoneNumerRequest());
}

function* apiData() {
  yield takeLatest(GET_PIN_FOR_AUTHORIZE, getPinForAuthorize);
  yield takeLatest(GET_CODE_OF_AUTHORIZE, getCodeOfAuthorize);
  yield takeLatest(EDIT_PHONE_NUMBER, _setPropsFormPhoneNumerRequest);
}

export default apiData;



// WEBPACK FOOTER //
// ./src/containers/ManualAccessPage/sagas.js